import { useEffect, useRef } from "react";

/**
 * Spec iter130 — mémorise la position de défilement (window) d'une liste par module
 * pendant la session et la restaure au retour, APRÈS le rendu des lignes (`ready`).
 * Réinitialisation : `clearScrollMemory(key)` (Réinitialiser les filtres) ; F5 = repart de zéro.
 */
export default function useScrollRestore(key, ready, selector = null) {
  const done = useRef(false);
  // `selector` : conteneur défilant interne (ex. "[data-testid=docs-list-scroll]") ; sinon la fenêtre.
  const getEl = () => (selector ? document.querySelector(selector) : null);
  useEffect(() => {
    if (!ready) return undefined;
    let t = null;
    const el = getEl();
    const target = el || window;
    const onScroll = () => {
      if (t) return;
      t = setTimeout(() => { t = null; try { sessionStorage.setItem(`${key}:scroll`, String(el ? el.scrollTop : window.scrollY)); } catch { /* ignore */ } }, 120);
    };
    target.addEventListener("scroll", onScroll, { passive: true });
    return () => { target.removeEventListener("scroll", onScroll); if (t) clearTimeout(t); };
  }, [key, ready, selector]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!ready || done.current) return;
    done.current = true;
    const y = Number(sessionStorage.getItem(`${key}:scroll`) || 0);
    if (!y) return;
    let tries = 0;
    const go = () => {
      const el = getEl();
      if (el) el.scrollTop = y; else window.scrollTo({ top: y });
      const cur = el ? el.scrollTop : window.scrollY;
      if (Math.abs(cur - y) > 4 && tries++ < 10) requestAnimationFrame(go);
    };
    requestAnimationFrame(go);
  }, [key, ready]); // eslint-disable-line react-hooks/exhaustive-deps
}

export const clearScrollMemory = (key, selector = null) => {
  try { sessionStorage.removeItem(`${key}:scroll`); } catch { /* ignore */ }
  const el = selector ? document.querySelector(selector) : null;
  if (el) el.scrollTop = 0; else window.scrollTo({ top: 0 });
};
